import { Typography } from "antd"
import SideMenu from "../../components/SideMenu/Index";
import '../index.css'

function Orders() {
    return (
    <div className="abc">
    <div className="ab"><SideMenu/></div>
    <div className="ac">
        <Typography.Title level={4}>School</Typography.Title>
    </div>

    </div>
    );
}
export default Orders